import { ReactComponent as CloseIcon } from '../../assets/icons/close.svg';
import { getPolicySections, getPolicyTitle } from '../../content/policies';

/**
 * 약관/동의서 스크롤 팝업.
 * 닫기 버튼은 스크롤과 무관하게 상단 고정 (피그마 가이드).
 */
export default function PolicyScrollPopup({ open, type, onClose }) {
  if (!open || !type) return null;

  const title = getPolicyTitle(type);
  const sections = getPolicySections(type);

  const onBackdropClick = (e) => {
    if (e.target === e.currentTarget) onClose?.();
  };

  return (
    <div
      className="fixed inset-0 z-[1000] flex items-end justify-center bg-black/45 sm:items-center"
      role="dialog"
      aria-modal="true"
      aria-label={title}
      onClick={onBackdropClick}
    >
      <div className="flex h-[min(88vh,780px)] w-full max-w-[480px] flex-col overflow-hidden rounded-t-[16px] bg-[#F0EAF7] sm:rounded-[16px]">
        <header className="relative z-10 flex h-[52px] shrink-0 items-center border-b border-solid border-black/5 bg-[#F0EAF7] px-4">
          <h2 className="flex-1 pr-8 text-center font-['Pretendard'] text-[16px] font-bold text-black">{title}</h2>
          <button
            type="button"
            aria-label="닫기"
            onClick={onClose}
            className="absolute right-3 top-1/2 flex h-10 w-10 -translate-y-1/2 items-center justify-center border-0 bg-transparent p-0"
          >
            <CloseIcon width={16} height={16} />
          </button>
        </header>

        <div className="min-h-0 flex-1 overflow-y-auto overscroll-contain px-4 pb-8 pt-4">
          <PolicyDocumentBody sections={sections} />
        </div>
      </div>
    </div>
  );
}

export function PolicyDocumentBody({ sections }) {
  if (!sections?.length) {
    return <p className="font-['Pretendard'] text-[14px] leading-[1.6] text-gray04">약관 내용을 불러올 수 없습니다.</p>;
  }

  return (
    <div className="flex flex-col gap-5 font-['Pretendard'] text-[14px] leading-[1.65] text-[#2E3548]">
      {sections.map((section, index) => (
        <section key={`${section.heading || 'body'}-${index}`} className="flex flex-col gap-2">
          {section.heading ? (
            <h3 className="text-[15px] font-bold leading-[1.4] text-black">{section.heading}</h3>
          ) : null}
          {section.body
            ? section.body.split('\n').map((line, lineIndex) => (
                <p key={lineIndex} className="m-0 whitespace-pre-wrap break-words">
                  {line}
                </p>
              ))
            : null}
        </section>
      ))}
    </div>
  );
}
